import { Button, Col, Descriptions, Form, InputNumber, message, Row, Select } from 'antd';
import { ReusableDataTable } from '@operations/shared';
import { useDispatch, useSelector } from 'react-redux';
import { request } from '../../../../../shared/src/apis';
import { stepperMoving } from '../../../stores/actions';
import { errorMessage } from '../../../utils/commonStringsConsts';
import { requestsDiscountApi } from '../../../utils/apisConsts';
import { useState } from 'react';

export default function SubmitNewDiscount() {
    const { Option } = Select;
    const userActiveAdvances = useSelector((state: any) => state?.actionsReducer?.advanceInstallments);
    const activeAdvanceData = useSelector((state: any) => state?.actionsReducer?.activeAdvanceData);
    const dispatch = useDispatch();
    const [loader, setLoader] = useState(false);
    const [prefix, setPrefix] = useState('amount');
    let columns = [
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Payments Amount',
            dataIndex: 'paymentsAmount',
            key: 'paymentsAmount',
        },
        {
            title: 'Principle',
            dataIndex: 'principle',
            key: 'principle',
        },
        {
            title: 'Revenue',
            dataIndex: 'revenue',
            key: 'revenue',
        },
        {
            title: 'Discounts',
            dataIndex: 'discounts',
            key: 'discounts',
        },
        {
            title: 'Payment Cycle',
            dataIndex: 'paymentCycle',
            key: 'paymentCycle',
        },
        {
            title: 'Collection Due Date',
            dataIndex: 'CollectionDueDate',
            key: 'CollectionDueDate',
        },
        {
            title: 'Cycle Cutoff Date',
            dataIndex: 'CycleCuttofDate',
            key: 'CycleCuttofDate',
        },
        {
            title: "Upcomming Revenue",
            dataIndex: 'upcommingRevenue',
            key: 'upcommingRevenue',
        }
    ];


    const submitForm = async (values: any) => {
        setLoader(true);
        const { discount, prefix } = values;
        const payloadData = {
            discount: discount,
            type: prefix,
            advanceID: activeAdvanceData?.advanceID,
        }
        try {
            const apiData: any = await dispatch(request({ method: 'POST', url: requestsDiscountApi, data: payloadData }))
            const res = await apiData?.data;
            console.log(apiData)
            if (res?.statusCode === 201 || res?.statusCode === 200) {
                message.success(res?.message, 5);
                dispatch(stepperMoving(0));
                return
            }
            message.error(res?.message, 5);
        } catch (error: any) {
            message.error(error?.response?.data?.statusCode === 400 ? error?.response?.data?.message : errorMessage)
        }
        setLoader(false);

    }

    const prefixSelector = (
        <Form.Item name="prefix" initialValue="amount" noStyle>
            <Select
                style={{ width: '120px' }}
                onChange={(value) => setPrefix(value)}
            >
                <Option value="amount">Amount</Option>
                <Option value="percent">Percent</Option>
            </Select>
        </Form.Item>
    );
    return (
        <>
            <div style={{ display: 'flex', flexDirection: 'column', marginTop: '20px' }} className='submitNewDiscount'>
                <ReusableDataTable columns={columns} hiddenRefreshing
                    apiLink={``} rows={userActiveAdvances}
                    pagination={false} loading={false} scrolling={true} />
                <Descriptions bordered className="py-2.5">
                    <Descriptions.Item key={1} span={3} label={"Max Allowed Discount Amount"}>
                        {userActiveAdvances[0]?.upcommingRevenue}
                    </Descriptions.Item>
                </Descriptions>
                <Form name="create" onFinish={submitForm} style={{ marginTop: '20px' }}>
                    <label>Discount {prefix === 'percent' ? '%' : ''}</label>
                    <Form.Item>
                        <Row gutter={8}>
                            <Col flex="auto">
                                <Form.Item
                                    name="discount"
                                    rules={[
                                        { required: true, message: 'Please input discount' },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                const prefix = getFieldValue('prefix');
                                                if (prefix === 'amount' && value < 0) {
                                                    return Promise.reject(new Error('Discount must be a positive number'));
                                                }
                                                if (prefix === 'amount' && value > activeAdvanceData?.maxAdvanceDiscount) {
                                                    return Promise.reject(new Error(`Amount cannot exceed ${activeAdvanceData?.maxAdvanceDiscount}`));
                                                }
                                                if (prefix === 'percent' && value > 100) {
                                                    return Promise.reject(new Error('percent cannot exceed 100%'));
                                                }
                                                return Promise.resolve();
                                            },
                                        }),
                                    ]}
                                    style={{ marginBottom: 0 }}
                                >
                                    <InputNumber addonAfter={prefixSelector} style={{ width: '100%' }} />
                                </Form.Item>
                            </Col>
                            <Col>
                                <Button type="primary" htmlType="submit" loading={loader}>
                                    Add Discount
                                </Button>
                            </Col>
                        </Row>
                    </Form.Item>
                </Form>
            </div>
        </>
    )
}

